import { render, staticRenderFns } from "./ShowArchive.vue?vue&type=template&id=742fddb5&"
import script from "./ShowArchive.vue?vue&type=script&lang=js&"
export * from "./ShowArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports